import type { PropsWithChildren, ReactNode } from "react";
import React, { Component } from "react";

import errorSent from "~/utils/errors/errorSent";

type ErrorBoundaryState = {
  hasError: boolean;
  error?: Error;
};

class ErrorBoundary extends Component<
  PropsWithChildren<Record<string, ReactNode>>,
  ErrorBoundaryState
> {
  constructor(props: PropsWithChildren<Record<string, ReactNode>>) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  // eslint-disable-next-line react/sort-comp
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("React error boundary captured an error:", error, errorInfo);
    errorSent(
      "reactErrorBoundary",
      error?.message || "notDetected",
      {
        errorName: error?.name,
        componentStack: errorInfo?.componentStack,
      },
      error,
    );
  }

  componentDidUpdate(
    prevProps: Readonly<PropsWithChildren<Record<string, ReactNode>>>,
  ) {
    if (this.state.hasError && this.props.children !== prevProps.children) {
      // reset error state on navigation or when the rendered tree changes
      // eslint-disable-next-line react/no-did-update-set-state,react/no-unused-state
      this.setState({ hasError: false, error: undefined });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            padding: "24px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              fontSize: "20px",
              margin: "50px 0",
              display: "flex",
              alignItems: "center",
              gap: "30px",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <img src="/logo.svg" style={{ maxWidth: 200 }} />
            <span>
              На сайте возникла ошибка( Мы уже работаем над ее решением
            </span>
            <span>
              Вы можете связаться с нами по телефону:{" "}
              <a href="tel:+7 (800) 777-52-78">+7 (800) 777-52-78</a>
            </span>
            {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
            <a href="/catalog/">Перейти в каталог</a>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
